<script>
    import { derived } from "svelte/store";

    import Currency from "commerce/currency/currency.svelte";

    import { isAppFeatureEnabled } from "commerce/lib/account-details";

    import Sub from "commerce/sub/sub.svelte";

    import { balance }     from "stores/balance";
    import { activeQuote } from "stores/active-quote";
    import { prompt }      from "stores/prompt";
    // import { disabled } from "stores/disabled";
    import { waiting } from "stores/toggles";

    import css from "./balance.css";

    const i18n = window.strings.exchange;

    const balanceDetails = derived([ activeQuote, prompt ], ([ $activeQuoteValue, $promptValue ]) => ({
        insufficient : $activeQuoteValue.type && $activeQuoteValue.disabled && !$promptValue,
        previewing   : $activeQuoteValue.type && !$activeQuoteValue.disabled && $promptValue !== "success" && isAppFeatureEnabled($activeQuote.what2what)
    }));
</script>

<div class="{css.balancesContainer}">
    <div class="hbox {css.balances}" data-preview={$balanceDetails.previewing}>
        {#each [ "coins", "gems" ] as balanceType}
            <div
                class="{css[`${balanceType}Balance`]} serif"
                data-insufficient={$balanceDetails.insufficient && $activeQuote.type !== balanceType}
                data-preview={$balanceDetails.previewing}
                data-success={$balance[`${balanceType}Success`]}
            >
                <Currency
                    type={balanceType}
                    amount={$balance[balanceType]}
                    options={{ align : true }}
                />
                {#if $balanceDetails.previewing}
                <span class="{css.hoverText}" data-preview={$balanceDetails.previewing}>
                    <Sub str={i18n.preview} key="balance">
                        <Currency
                            type={balanceType}
                            amount={$balance.preview[balanceType]}
                            prevAmount={$balance[balanceType]}
                            options={{ align : true, waiting : $waiting, duration : 300 }}
                        />
                    </Sub>
                </span>
                {/if}

                <span class="{css.hoverText}" data-insufficient={$balanceDetails.insufficient && balanceType !== $activeQuote.type}>
                    {i18n.insufficient[balanceType === "coins" ? "gold2gems" : "gems2gold" ]}
                </span>
            </div>
        {/each}
    </div>
</div>





